import { useContext } from 'react'

import { useBloc } from './bloc'
import {
  type ContextoDeNotificacoesGlobalProps,
  NotificacoesContexto,
  type NotificacoesContextoData,
} from './tipos'

export function ContextoDeNotificacoesGlobal({
  children,
}: ContextoDeNotificacoesGlobalProps): JSX.Element {
  const estadoDasNotificacoes = useBloc()

  return (
    <NotificacoesContexto.Provider value={estadoDasNotificacoes}>
      {children}
    </NotificacoesContexto.Provider>
  )
}

export function useNotificacoes(): NotificacoesContextoData {
  const context = useContext(NotificacoesContexto)

  if (!context) {
    throw new Error(
      'useNotificacoes deve ser usado dentro de ContextoDeNotificacoesGlobal'
    )
  }

  return context
}

export type { NotificacoesContextoData } from './tipos'
